// AUTO-GENERATED — DO NOT EDIT
//     run `just codegen-experiment-function … --frontend-client --target-app ask` to regenerate.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useCometMcpEnabledVariation = makeBooleanFlagValueHook('comet-mcp-enabled');
//# sourceMappingURL=useCometMcpEnabledVariation.js.map